import React,{useState,useEffect} from "react";
import EditButton from "./EditButton";
import SingleArticleBox from "./SingleArticleBox";
import ArticleSelector, { ARTICLE_1, ARTICLE_2, ARTICLE_3 } from "./ArticleSelector";
import FocusedArticle from "./FocusedArticle";
import { useGlobal } from "./Reducer";
import Api, { BUILD, eSOT } from "./Api";
import ExpandedViewArticle from "./ExpandedViewArticle";

 export default ()=>
    {





        const [showEditor,setShowEditor]=useState(false);
        const [articleIndex,setArticleIndex]=useState(0);
        const [gs,ga]=useGlobal();
        const [articles,setArticles]=useState({});
        const [expand,setExpand]=useState({})

            useEffect(()=>{
             
                    ga.loading(true);
                    Api.getArticleByIds(
                        gs.appData.article_1,
                        gs.appData.article_2,
                        gs.appData.article_3
                        ).then((articles)=>{
                     
                            setArticles(articles);
                        }).catch(err=>{
                            alert(err);
                        }).finally(()=>{
                            ga.loading(false);
                        });


            },[  
                gs.appData.article_1,
                gs.appData.article_2,
                gs.appData.article_3
                

            ])
        
        
        const showEditorFor=(article)=>{
            setArticleIndex(article);    
            setShowEditor(true);
        }

        const expandView=(art)=>{
            setExpand(art);
            
        }


        return (
        <React.Fragment>

{showEditor && <ArticleSelector 
                    articleIndex={articleIndex}
            onClose={()=>setShowEditor(false)}/>}

{BUILD==eSOT &&<React.Fragment>  
    <div style={{fontSize:28}}  className="men-header d-none d-lg-block    row ng-binding">
                {gs.appData.headers.title}
            </div>
              
    
                <div style={{marginTop:20}}>
                <div className="row">
                    <div className="col ogn_line_before"> <FocusedArticle 
                    article={articles[gs.appData.article_1]}
                    setShowEditor={()=>{
                        showEditorFor(ARTICLE_1);
                    }}
                    /></div>
                </div>
               
                </div>
                </React.Fragment>}
            
        <div className="men-header row">
	Articles

    </div>
	{!expand.id && <div className="row" id="allnewsarea"  ng-show="in_the_news">

                    <SingleArticleBox 
                    expandView={(art)=>expandView(art)}
                    article={articles[gs.appData.article_2]}
                    setShowEditor={()=>{
                         showEditorFor(ARTICLE_2);
                    }}/>
          
                    <SingleArticleBox 
                    expandView={(art)=>expandView(art)}
                    article={articles[gs.appData.article_3]}
                    setShowEditor={()=>{
                         showEditorFor(ARTICLE_3);
                    }}/>
             



	</div>}
                  
    {expand.id!=null  && <ExpandedViewArticle 
        onClose={()=>{
            setExpand({});
        }}
    article={expand} articles={[articles[gs.appData.article_2],articles[gs.appData.article_3]]} />}
    </React.Fragment>);
    }

    